export default __webpack_public_path__ + "static/media/icon-algowork-n.146884f0.webp";